import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import '../less/club.less';


export default class clubSidebar extends Component {
    constructor(props) {
        super(props)

        this.state = {
            activePath: ''
        }
    }

    renderLinks = (sideList) => {
        const _this = this
        return sideList.map(item => {
            return (
                <li key={item.bigtit}>
                    <h5 className={item.className}>{item.bigtit}</h5>
                    <ul className="item-list">
                        {_this.renderSubLinks(item.littit)}
                    </ul>
                </li>
            )
        })
    }

    renderSubLinks = (subList) => {
        const _this = this
        return subList.map((item, index) => {
            return <li className={item.path === _this.state.activePath ? 'active':''} key={item.litName}><Link to={item.path}>{item.litName}</Link></li>
        })
    }

    componentWillMount () {
        let curPath = window.location.href.substring(window.location.href.lastIndexOf('/')+1, window.location.href.length)
        this.setState({
            activePath: "/" + curPath
        })
    }

    componentWillReceiveProps (){
        let curPath = window.location.href.substring(window.location.href.lastIndexOf('/')+1, window.location.href.length)
        this.setState({
            activePath: "/" + curPath
        })
    }
    render() {
        const { sideList } = this.props
        return (
            <div className="sidebar">
                <ul className="nav">
                    {this.renderLinks(sideList)}
                </ul>
            </div>

        );
    }
}
